import React, { useEffect, useState, lazy } from 'react'
import { useTranslate, useNotify } from 'react-admin';
import { Link } from "react-router-dom";
import { LoaderApp } from "../../../components/layout/LoaderApp";
import {
    Input,
    Button,
    CircularProgress,
    Typography,
    Box,
    makeStyles,
    Select,
    TextField,
    FormControl,
    Checkbox
} from "@material-ui/core";
import MenuItem from '@material-ui/core/MenuItem';
import bcrypt from 'bcryptjs';
import ModalTerms from "./ModalTerms";

const useStyles = makeStyles((theme) => ({
    title: {
        color: "#2D4050",
        fontWeight: "bold",
        marginBottom: 5,
        textAlign: "center",
    },
    contentText: {
        color: "#888888",
        fontWeight: "normal",
        fontSize: 16,
        margin: 0,
        marginBottom: 25,
        textAlign: "center",
    },
}));



export const LimitExpirationPassword = ({ updateAttributesUsers }) => {
    const classes = useStyles();
    const translate = useTranslate();
    const [value, setValue] = useState("1");
    const [btnSubmit, setBtnSubmit] = useState(true);
    const [acceptTerms, setAcceptTerms] = useState(false);
    const [showModalTerms, setShowModalTerms] = useState(false);
    const notify = useNotify();

    const handleChangePassword = async (data, event) => {
        const salt = bcrypt.genSaltSync(10);
        const hashedPin = bcrypt.hashSync(data.target.querySelector('#pin').value, salt);
        if (acceptTerms) {
            updateAttributesUsers(value, hashedPin);

        } else {
            setBtnSubmit(true)
            notify("ra.notification.acceptTerms", "warning");
        }
        // Store the hashedPin value in the pin_bancaribe field in Cognito

    }

    useEffect(() => {
        setBtnSubmit(true)
    }, [])

    return (
        <>
            {
                btnSubmit === "loading" && (
                    <LoaderApp />
                )
            }
            <form
                style={{ width: "95%", maxWidth: 410 }}
                onSubmit={(e) => {
                    e.preventDefault();
                    handleChangePassword(e);
                }}
            >
                <Typography variant="h5" className={classes.title}>
                    {translate("ra.auth.limitPassword")}
                </Typography>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    gridGap="22px"
                    width="100%"
                    margin="0 auto"
                    marginTop="20px"
                    maxWidth="410px"
                >

                    <Select
                        style={{ width: '100%', height: '60px' }}
                        variant="outlined"
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        select
                        label={false}
                    >
                        <MenuItem key={1} value="1">
                            {`1 ${translate("ra.weekDays.day")}`}
                        </MenuItem>
                        <MenuItem key={2} value="30">
                            {`30 ${translate("ra.weekDays.day")}s`}
                        </MenuItem>
                        <MenuItem key={3} value="60">
                            {`60 ${translate("ra.weekDays.day")}s`}
                        </MenuItem>
                        <MenuItem key={4} value="180">
                            {`180 ${translate("ra.weekDays.day")}s`}
                        </MenuItem>
                    </Select>

                    <Typography variant="h5" className={classes.title}>
                        {translate("ra.auth.pin_bancaribe")}
                    </Typography>

                    <Input
                        fullWidth
                        id="pin"
                        placeholder={translate("ra.auth.pin_bancaribe")}
                        type="text"
                        style={{ height: '60px', padding: "20px" }}
                        inputProps={{
                            pattern: '[0-9]*',
                            maxLength: 4,
                            style: { height: '80px !important' },
                        }}
                        onInput={(event) => {
                            event.target.value = event.target.value.replace(/[^0-9]/g, "");
                        }}
                        disableUnderline={true}
                        required={true}
                    />

                    <Box mt={6} >
                        <Typography variant="body2" color="textSecondary">
                            <Checkbox
                                id="accept-terms"
                                checked={acceptTerms}
                                onChange={(e) => setAcceptTerms(e.target.checked)}
                            />
                            <label for="accept-terms">
                                He leído y acepto los <a href="#" onClick={(e) => { e.preventDefault(); setShowModalTerms(true); }}>términos y condiciones</a>
                            </label>
                        </Typography>
                    </Box>

                    <Button
                        fullWidth
                        type="submit"
                        variant={btnSubmit === "loading" ? "outlined" : "contained"}
                        color="primary"
                        style={{ margin: 5, marginBottom: 15, borderRadius: '10px' }}
                        //onClick={handleChangePassword}
                        size="large"
                    >
                        {btnSubmit === "loading" ? (
                            <CircularProgress color="primary" size="1.5rem" />
                        ) : (
                            translate("ra.action.save")
                        )}
                    </Button>
                    <Link
                        to="/login"
                        style={{ width: "100%", textDecoration: "none" }}
                    >
                        <Button fullWidth variant="outlined" color="inherit" size="large">
                            {translate("ra.action.goBack")}
                        </Button>
                    </Link>
                </Box>
                <ModalTerms
                    openModal={showModalTerms}
                    setOpenModal={setShowModalTerms}
                />
            </form>


        </>


    )
}
